/**
 * Form düzeni — Vuexy 10.11 `pages-account-settings` BİREBİR:
 *
 *   <div class="row gy-4 gx-6">            → 2 sütunlu ızgara, dikey 16px / yatay 24px
 *     <div class="col-md-6">               → alan yarım genişlik; uzun metin tam genişlik
 *       <label class="form-label">         → 13px, başlık rengi, altında 4px
 *       <input class="form-control">
 *       <div class="form-text">            → 13px soluk yardım metni
 *
 * Etiket ALANIN ÜSTÜNDE. Önceki düzen (sol etiket sütunu + satır ayraçları) bir
 * "ayar listesi" gibi okunuyor, kart içinde kat hissi vermiyordu — kullanıcı
 * "nizam yok" dedi. Vuexy'de ayraç çizgisi yok; hiyerarşiyi kart başlığı, ızgara
 * ve boşluk kurar.
 *
 * Kap sorgusu: ızgara ekrana değil KABA bakar (`@2xl` ≈ 672px). Dar kartta tek sütun.
 */

import type { ReactNode } from 'react';
import { cn } from '../../lib/cn';

export function Form({ children, className }: { children: ReactNode; className?: string }) {
  // row gy-4 gx-6
  return (
    <div className={cn('kap grid w-full grid-cols-1 gap-x-6 gap-y-4 @2xl:grid-cols-2', className)}>
      {children}
    </div>
  );
}

export interface FormSatiriProps {
  etiket: string;
  /** Alanın altındaki yardım metni (Vuexy `form-text`). */
  aciklama?: string | null;
  htmlFor?: string;
  zorunlu?: boolean;
  /** Açıklamaya ek, daha soluk ipucu (kaynak rozeti vb.). */
  ipucu?: ReactNode;
  hata?: string | null;
  /** Uzun metin / anahtar gibi alanlar iki sütunu kaplar (`col-12`). */
  tam?: boolean;
  children: ReactNode;
}

export function FormSatiri({
  etiket,
  aciklama,
  htmlFor,
  zorunlu = false,
  ipucu,
  hata,
  tam = false,
  children,
}: FormSatiriProps) {
  return (
    <div className={cn('flex min-w-0 flex-col gap-1', tam && '@2xl:col-span-2')}>
      {/* .form-label: 13px, başlık rengi, mb .25rem */}
      <label htmlFor={htmlFor} className="text-[0.8125rem] text-[var(--ink)]">
        {etiket}
        {zorunlu && (
          <span className="ml-1 text-[var(--state-bad)]" title="Zorunlu alan" aria-hidden="true">
            *
          </span>
        )}
      </label>

      {children}

      {hata ? (
        <span className="text-xs text-[var(--state-bad)]">{hata}</span>
      ) : (
        (aciklama || ipucu) && (
          // .form-text
          <span className="text-xs text-[var(--ink-muted)]">
            {aciklama}
            {aciklama && ipucu ? ' ' : null}
            {ipucu}
          </span>
        )
      )}
    </div>
  );
}

/**
 * Form alt çubuğu — kaydet/vazgeç.
 *
 * Yapışkan: uzun formda kullanıcı kaydet düğmesini aramak için sona kaydırmak
 * zorunda kalmasın. Değişiklik yoksa görünmez — boş bir çubuk yer kaplamasın.
 */
export function FormAltCubugu({ gorunur, children }: { gorunur: boolean; children: ReactNode }) {
  if (!gorunur) return null;
  return (
    <div className="sticky bottom-0 z-10 -mx-4 mt-2 flex flex-wrap items-center gap-3 border-t border-[var(--line)] bg-[color-mix(in_srgb,var(--surface)_95%,transparent)] px-4 py-3 backdrop-blur">
      {children}
    </div>
  );
}
